import { useCallback, useState } from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';

export const DatePickerInput = ({ error, defaultValue, onChange }) => {
  const [value, setValue] = useState(defaultValue || new Date());

  const isError = !!error;
  const handleChange = useCallback((val) => {
    setValue(val);
    onChange(val);
  }, []);

  return (
    <div>
      <DatePicker id="ticketspot-questions-datepicker" selected={value} onChange={(date) => handleChange(date)} />
      {isError && (
        <div className="invalid-feedback" style={{ display: 'block' }}>
          {error}
        </div>
      )}
    </div>
  );
};
